import { render, staticRenderFns } from "./model_category.vue?vue&type=template&id=b330ba12&scoped=true"
import script from "./model_category.vue?vue&type=script&lang=js"
export * from "./model_category.vue?vue&type=script&lang=js"
import style0 from "./model_category.vue?vue&type=style&index=0&id=b330ba12&prod&rel=stylesheet%2Fscss&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b330ba12",
  null
  
)

export default component.exports